import { render, staticRenderFns } from "./voluntaryScheme.vue?vue&type=template&id=6efec72a&scoped=true"
import script from "./voluntaryScheme.vue?vue&type=script&lang=js"
export * from "./voluntaryScheme.vue?vue&type=script&lang=js"
import style0 from "./voluntaryScheme.vue?vue&type=style&index=0&id=6efec72a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efec72a",
  null
  
)

export default component.exports